import { render, staticRenderFns } from "./TransporterTransfer.vue?vue&type=template&id=4f5f82c6&scoped=true&"
import script from "./TransporterTransfer.vue?vue&type=script&lang=js&"
export * from "./TransporterTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TransporterTransfer.vue?vue&type=style&index=0&id=4f5f82c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f82c6",
  null
  
)

export default component.exports